import React, { useEffect } from 'react';
import M from 'materialize-css';

function CollapsibleGroup({ innerItems }) {
  const initLoading = () => {
    var elems = document.querySelectorAll('.collapsible');
    M.Collapsible.init(elems);
  };

  useEffect(initLoading, []);

  return (
    <ul className="collapsible popout">
      {innerItems()}
    </ul>
  )
}

export default CollapsibleGroup;
